import { BlogService, CategoryService } from '@core/services';
import { SocialService } from '@core/services/social';
import { Component, DefineDependencies } from '@rhtml/component';
import { AngularLayout } from '@rhtml/modifiers';
import { Container, Inject } from '@rxdi/core';
import { css, html, LitElement, state } from '@rxdi/lit-html';
import { Router } from '@rxdi/router';
import { ModalViewService } from '@shared/services';
import { filter, switchMap } from 'rxjs/operators';
import { success } from 'toastr';

/**
 * @customElement footer-component
 */
@Component({
  Settings: {
    selector: 'footer-component',
    style: css`
      .footer {
        position: fixed;
        right: 0;
        bottom: 0;
      }

      .icon {
        display: flex;
        padding: 10px;
        background: var(--primary-color);
        border-radius: 30px;
        margin-right: 15px;
        margin-bottom: 15px;
        cursor: pointer;
        position: absolute;
        bottom: 0;
        right: 0;
      }

      .icon:hover {
        opacity: 0.9;
      }

      sl-icon {
        color: white;
        width: 30px;
        height: 30px;
      }
    `,
    modifiers: [...AngularLayout],
  },
  Providers: DefineDependencies(SocialService)(Container),
  State: function (this: FooterComponent, [socialService]) {
    return socialService.isLoggedIn;
  },
  Render: () =>
    function (this, state) {
      console.log(state);
      return html`
        <div ngIf=${state} class="footer">
          ${this.showMenu
            ? html`
                <div style="position: absolute; bottom: 75px; right: 40px;">
                  <sl-menu>
                    <sl-menu-item @click=${() => this.createPost()}>Create Post</sl-menu-item>
                    <sl-menu-item @click=${() => this.createCategory()}>Create Category</sl-menu-item>
                    <sl-menu-item @click=${() => this.getMyDrafts()}>My Drafts</sl-menu-item>
                    <sl-menu-item @click=${() => this.logout()}>Logout</sl-menu-item>
                  </sl-menu>
                </div>
              `
            : ''}
          <div
            class="icon"
            @click=${() => {
              this.showMenu = !this.showMenu;
            }}
          >
            <sl-icon name="patch-plus"></sl-icon>
          </div>
        </div>
      `;
    },
})
export class FooterComponent extends LitElement {
  @Router()
  router: Router;

  @state()
  showMenu: boolean;

  @Inject(BlogService)
  private blogService: BlogService;

  @Inject(CategoryService)
  private categoryService: CategoryService;

  @Inject(ModalViewService)
  private modal: ModalViewService;

  @Inject(SocialService)
  private socialService: SocialService;

  createPost() {
    this.categoryService
      .listCategories()
      .pipe(
        switchMap((categories) => this.modal.openSelectCategoryModal(null, categories)),
        filter((v) => !!v),
        switchMap(({ id }) =>
          this.blogService.createPost({
            category: id,
            content: 'Lorem Ipsum Dolor dolor simet',
            title: 'Ipsum mipsum boren pipsum ipsum simet',
            draft: true,
          })
        )
      )
      .subscribe(({ category, searchKey }) => {
        this.router.go(`/blog/${category.searchKey}/${searchKey}/edit`);
        this.showMenu = false;
        success('Post created successfully');
      });
  }

  createCategory() {
    this.categoryService
      .listCategories()
      .pipe(
        switchMap((categories) => this.modal.openCreateCategoryModal(null, categories)),
        filter((v) => !!v),
        switchMap((category) => this.categoryService.createCategory([category]))
      )
      .subscribe(([category]) => {
        this.router.go(`/blog/${category.searchKey}`);
        this.showMenu = false;
        success('Category created successfully');
      });
  }

  getMyDrafts() {
    this.router.go('/blog/all?draft=true');
    this.showMenu = false;
  }

  logout() {
    this.socialService.signOut().subscribe();
  }
}
